export const INGESTION_CUSTOM_FIELD_PREFIX = 'custom_field_';
